import { SHOW_MODAL, HIDE_MODAL } from '@/state/types/modal'

// Initial State
export const initialState = {
  params: {},
  visible: false,
}

// Reducer
export default function modals(state = initialState, action) {
  const { type, payload = {} } = action || {}
  switch (type) {
    case SHOW_MODAL:
      return {
        ...state,
        params: payload,
        visible: true,
      }

    case HIDE_MODAL:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./state/reducers/modal.js